var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5C12.145 5 9 8.145 9 12C9 14.41 10.23 16.55 12.094 17.813C8.527 19.343 6 22.883 6 27H8C8 22.57 11.57 19 16 19C20.43 19 24 22.57 24 27H26C26 22.883 23.473 19.344 19.906 17.812C20.8573 17.1698 21.6368 16.3042 22.1762 15.291C22.7156 14.2778 22.9984 13.1478 23 12C23 8.145 19.855 5 16 5ZM16 7C18.773 7 21 9.227 21 12C21 14.773 18.773 17 16 17C13.227 17 11 14.773 11 12C11 9.227 13.227 7 16 7Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyprofile);
export default __webpack_public_path__ + "static/media/myprofile.370bfe310dd4bb9d87c62c795e2cdbc1.svg";
export { ForwardRef as ReactComponent };